import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { storeContext } from "../../../../../store/root-store";
import { IFilterDate } from "../../../../../store/FilterDates";

export const AdminDatesPanel = observer(() => {
  const { adminDateFilterGl } = useContext(storeContext);

  const onPickDate = async (filterDate: IFilterDate) => {
    await adminDateFilterGl.onPickDate(filterDate);
  };

  return (
    <div>
      <div
        className="full-list-of-tags base-page-element"
        style={{ fontSize: 0.8 + "rem", paddingTop: 0.3 + "rem" }}
      >
        {adminDateFilterGl.listOfDates.map((el) => {
          return (
            <div
              key={el.dateSec}
              onClick={() => onPickDate(el)}
              className={
                "full-list-of-tags-item " +
                (adminDateFilterGl.listOfSelectedDates.has(el)
                  ? "full-list-of-tags-item-selected"
                  : "")
              }
            >
              <div className="full-list-of-tags-item-text">{el.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
